import { useContext } from 'react';

import { NavigationPathContext } from '../components/NavigationPathProvider';

/** 지금 화면까지의 길과 화면 이름. Provider 밖에서 쓰면 던진다. */
export const useNavigationPath = () => {
  const value = useContext(NavigationPathContext);
  if (!value) {
    throw new Error(
      'useNavigationPath 는 NavigationPathProvider(_app) 안에서만 쓴다.',
    );
  }
  return value;
};
